// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:15:34

export default {
  "id": "drunk-man-3d",
  "slug": "drunk-man-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f5227a5977c84a1d819702f88688ed80-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f5227a5977c84a1d819702f88688ed80/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Drunk Man 3D",
      "description": "Drunk Man 3D is a challenging and comedic 3D Ragdoll Physics game. In this game, players must navigate a treacherous cityscape while emulating the hindered balance of inebriation. The game features ragdoll physics, where even minor collisions can cause players to lose control and stumble.",
      "instructions": "WASD or Arrow keys",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "3d",
        "obstacles",
        "ragdoll",
        "run",
        "running"
      ]
    },
    "zh-CN": {
      "title": "醉汉3D",
      "description": "《醉酒男子3D》是一款具有挑战性和喜剧性的3D布娃娃物理游戏。在这款游戏中，玩家必须在一个危险的城市景观中导航，同时模拟醉酒时的失衡。游戏采用布娃娃物理，即使是轻微的碰撞也可能导致玩家失去控制而跌倒。",
      "instructions": "WASD或方向键",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "三维",
        "障碍物",
        "布娃娃效果",
        "奔跑",
        "跑步"
      ]
    },
    "zh-TW": {
      "title": "酩酊大醉3D",
      "description": "Drunk Man 3D 是一款挑戰性與喜劇性並存的 3D Ragdoll Physics 遊戲。在這款遊戲中，玩家必須在模擬酒後失去平衡的情況下，穿梭於危險的城市景觀。遊戲採用 Ragdoll Physics，即使是微小的碰撞也會導致玩家失去控制而跌倒。",
      "instructions": "WASD或方向鍵",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "3D",
        "障礙物",
        "拉力娃娃",
        "奔跑",
        "跑步"
      ]
    },
    "zh-HK": {
      "title": "酩酊大醉3D",
      "description": "酩酊大醉3D是一款挑戰性及幽默的3D Ragdoll物理遊戲。在這款遊戲中，玩家需在模擬酒醉狀態下受阻的平衡能力，穿梭於危險的城市風景中。遊戲特色為ragdoll物理效果，即使微小的碰撞也可能導致玩家失去控制並跌倒。",
      "instructions": "WASD 或 順針方向鍵",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "3D",
        "障礙物",
        "拉格鈎",
        "奔跑",
        "跑步"
      ]
    },
    "ja": {
      "title": "酔った男3D",
      "description": "Drunk Man 3Dは挑戦的でユーモラスな3Dラグドール物理ゲームです。このゲームでは、飲んだくれのバランスが崩れるように操作して危険な都市の地形を進む必要があります。ゲームにはラグドール物理が特徴で、小さな衝突でさえプレイヤーがコントロールを失い転びやすい仕様になっています。",
      "instructions": "WASDまたは矢印キー",
      "genres": [
        "敏捷性",
        "カジュアル"
      ],
      "tags": [
        "3D",
        "障害物",
        "ラグドール",
        "走る",
        "走行"
      ]
    },
    "ko": {
      "title": "빠진 남자 3D",
      "description": "드러크맨 3D는 도전적이고 코믹한 3D Ragdoll Physics 게임입니다. 이 게임에서 플레이어는 음주 후 불편한 균형을 흉내내며 위험한 도시 풍경을 탐험해야 합니다. 게임은 Ragdoll Physics를 특징으로 하며, 작은 충돌로도 플레이어가 통제를 잃고 미끄러지게 됩니다.",
      "instructions": "WASD 또는 방향키",
      "genres": [
        "敏捷度",
        "캐주얼"
      ],
      "tags": [
        "3D",
        "장애물",
        "랩돌",
        "달리기",
        "달리다"
      ]
    },
    "fr": {
      "title": "Homme ivre 3D",
      "description": "Drunk Man 3D est un jeu de physique 3D amusant et défiants où les Ragdoll Physics sont au centre. Dans ce jeu, les joueurs doivent se faufiler dans un environnement urbain périlleux tout en imitant l'équilibre perturbé de l'ébriété. Le jeu propose des physique ragdoll, où même les collisions mineures peuvent entraîner la perte de contrôle et des chutes.",
      "instructions": "WASD ou touches fléchées",
      "genres": [
        "Agilité",
        "Occasionnel"
      ],
      "tags": [
        "3D",
        "obstacles",
        "ragdoll",
        "courir",
        "course"
      ]
    }
  }
};
